import * as constants from '../config/constants.js';
import ClassList from 'classlist';

export default class ElementClassHandler {
    alertError(element) {
        this.remove(element, constants.ALERT_SUCCESS_CLASS);
        this.add(element, constants.ALERT_CLASS);
        this.add(element, constants.ALERT_ERROR_CLASS);
    }

    alertSuccess(element) {
        this.remove(element, constants.ALERT_ERROR_CLASS);
        this.add(element, constants.ALERT_CLASS);
        this.add(element, constants.ALERT_SUCCESS_CLASS);
    }

    removeAlerts(element) {
        this.remove(element, constants.ALERT_CLASS);
        this.remove(element, constants.ALERT_ERROR_CLASS);
        this.remove(element, constants.ALERT_SUCCESS_CLASS);
    }

    hide(element) {
        this.add(element, constants.HIDE_ELEMENT_CLASS);
    }

    show(element) {
        this.remove(element, constants.HIDE_ELEMENT_CLASS);
    }

    hideElements(list) {
        list.forEach(item => this.hide(item));
    }

    showElements(list) {
        list.forEach(item => this.show(item));
    }

    add(element, className) {
        const classList = new ClassList(element);
        if (!classList.contains(className) && className) {
            classList.add(className);
        }
    }

    remove(element, className) {
        const classList = new ClassList(element);
        if (className) {
            classList.remove(className);
        }
    }

    toggle(element, className) {
        const classList = new ClassList(element);
        classList.toggle(className);
    }
}
